import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0451ccc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "verification-cancel-popover mha-font-body-sm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Patient Verification", -1))
const _hoisted_3 = { class: "m-t-8 p-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Would you like to cancel the patient verification? ")
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = { class: "d-flex flex-item-grow m-r-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-text" }, "Cancel", -1))
const _hoisted_9 = { class: "d-flex flex-item-grow m-l-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-text" }, "Cancel Verification", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_DefaultPopover = _resolveComponent("DefaultPopover")!

  return (_openBlock(), _createBlock(_component_DefaultPopover, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" This patient was verified on " + _toDisplayString(_ctx.verificationDate) + " by " + _toDisplayString(_ctx.connectionStatus.verifier_user_name) + ". ", 1),
          _hoisted_4,
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_BaseButton, {
              class: "flex-item-grow",
              pattern: _ctx.ButtonColorPattern.DEFAULT,
              color: _ctx.ButtonColor.PRIMARY,
              size: _ctx.ButtonSize.X_SMALL,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popoverController.dismiss()))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["pattern", "color", "size"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BaseButton, {
              class: "flex-item-grow",
              pattern: _ctx.ButtonColorPattern.FILL,
              color: _ctx.ButtonColor.PRIMARY,
              size: _ctx.ButtonSize.X_SMALL,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelVerification()))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["pattern", "color", "size"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}